var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToolButton',{attrs:{"Editor":_vm.Editor,"KnownIcon":"Publish","Size":10},on:{"ToolClick":function($event){return _vm.Clicked()}}})}
var staticRenderFns = []

export { render, staticRenderFns }